import { createRoot, type Root } from "react-dom/client";
import Contact from "../pages/Contact/Contact";
import "../index.css";
import "../pages/Contact/Contact.custom.css";

let root: Root | null = null;

function mount(element: HTMLElement) {
  if (root) return;

  root = createRoot(element);
  root.render(<Contact />);
}

function unmount() {
  root?.unmount();
  root = null;
}

window.ACADContact = { mount, unmount };

function boot() {
  const element = document.getElementById("contact-root");
  if (element) mount(element);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", boot, { once: true });
} else {
  boot();
}
